<template>
  <div>
    <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card flat v-else>
      <v-card class="pt-2 ma-2 mt-3" max-width="100%" v-if="Show == false" flat>
        <v-data-table
          dense
          v-model="selected"
          :search="search"
          class="elevation-1"
          :headers="headers"
          :items="partialPending"
          show-select
          item-key="expense_id"
          :options.sync="pagination"
          :items-per-page="itemsPerPage"
          @update:options="getExpenseApprDataPagination()"
          :no-data-text="Nodata"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ partialPending.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.user_detail`]="{ item }">
            <span class="caption"
              ><b>{{ item.user_detail.user_name }}</b></span
            >
            <br />
            <!-- </template>
         
        <template v-slot:[`item.mobile_no`]="{ item }"> -->
            <span class="caption">{{ item.user_detail.mobile_no }}</span>
          </template>

          <template v-slot:[`item.total_amount`]="{ item }">
            <span class="caption"> {{ item.total_amount }}</span>
          </template>
          <template v-slot:[`item.remaining_amount`]="{ item }">
            <span class="caption"> {{ item.remaining_amount }}</span>
          </template>

          <template v-slot:[`item.transactionNumber`]="{ item }">
            <span class="caption">{{ item.transactionNumber }}</span>
          </template>
          <template v-slot:[`item.created_on`]="{ item }">
            <span class="caption">{{ item.created_on }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div v-if="item.status == '0'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="caption orange--text font-weight-medium"
                    >PENDING</span
                  >
                </template>
                <span>PENDING FOR APPROVAL</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '1'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption green--text font-weight-medium"
                    >APPROVED</span
                  >
                </template>
                <span>APPROVED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '2'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption red--text font-weight-medium"
                    >REJECTED</span
                  >
                </template>
                <span>REJECTED</span>
              </v-tooltip>
            </div>
            <div v-if="item.status == '3'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="caption pink--text font-weight-medium"
                    >PARTIAL APPROVED</span
                  >
                </template>
                <span>PARTIAL APPROVED</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="showContent(item)"
                  small
                  class="mr-2"
                  v-on="on"
                  color="primary"
                  :disabled="
                    checkaccessdata.is_viewer == false &&
                    checkaccessdata.is_checker == false
                  "
                  >mdi-eye</v-icon
                >
              </template>
              <span>view details</span>
            </v-tooltip>
          </template>
          <template v-slot:top>
            <v-row class="ml-2 mt-1 mr-2">
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-select
                  v-model="selectPayee"
                  :items="UserList"
                  label="Select Employee"
                  item-text="full_name"
                  item-value="userid"
                  dense
                  outlined
                ></v-select>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogStart"
                  v-model="modalStart"
                  :return-value.sync="start_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="start_date"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="start_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalStart = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogStart.save(start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEnd"
                  :return-value.sync="end_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      color="primary"
                      dense
                      v-model="end_date"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="end_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <!-- <v-col lg="2">
                  <label class="caption">Status</label>
                  <v-select v-model="statusType" :items="statusList" dense solo label="Status"></v-select>
              </v-col>-->

              <v-col cols="12" lg="1" xl="1" md="1" sm="12" xs="12">
                <v-btn
                  small
                  fab
                  text
                  color="primary"
                  class="elevation-0"
                  @click="getExpenseApprData()"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" lg="3" xl="3" md="3" sm="12" xs="12">
                <v-text-field
                  dense
                  shaped
                  outlined
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row
              class="mb-2"
              v-if="selected.length != 0 && checkaccessdata.is_approver == true"
            >
              <v-spacer />
              <v-col cols="12" lg="4" xl="4" md="4" sm="6" xs="6">
                <v-chip color="primary" outlined label class="ml-2 mr-2">
                  <span class="red--text subtitle-2">
                    <b class="primary--text">Total Amount :</b>
                    MYR {{ totalPayment }}
                  </span>
                </v-chip>

                <v-btn
                  dence
                  color="primary"
                  style="font-size: 12px; height: 32px"
                  @click="actionDialogeStatus1()"
                  >Collect Amount</v-btn
                >
              </v-col>
            </v-row>

            <v-row
              align="center"
              justify="center"
              v-if="
                selected.length != 0 && checkaccessdata.is_approver == false
              "
              class="mb-4"
            >
              <span class="red--text"
                ><b>You Don't Have Access To Approve</b></span
              ></v-row
            >
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="actionDialogeStatus" width="500">
        <v-card>
          <v-toolbar flat class="header" dense dark>
            <v-icon>mdi-cash-multiple</v-icon>
            <span class="ml-3">Collect Amount</span>
            <v-spacer></v-spacer>
            <v-btn class text dark @click="actionDialogeStatus = false">
              <v-icon color="white" small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="mt-4">
            <v-form ref="commentForm">
              <v-row>
                <v-col cols="12" class="mt-1">
                  <v-text-field
                    v-model="amount"
                    label="Amount"
                    outlined
                    readonly
                    dense
                    required
                    @keypress="isNumber(event)"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="mt-n3">
                  <v-textarea
                    outlined
                    dense
                    label="Comment"
                    rows="3"
                    v-model="commentExpense"
                    auto-grow
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="white--text mt-n6 mb-2"
              color="primary"
              depressed
              @click="collectamt()"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-dialog v-model="contentDialog" max-width="500">
      <v-card>
        <v-toolbar flat color="primary" dense dark>
          <v-toolbar-title>DETAILS</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class text dark @click="contentDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12">
              <span class="subtitle-2">
                <b class="primary--text">Expense Name :</b>
                {{ itemfield.expense_name }}
              </span>
              <br />
              <span class="subtitle-2">
                <b class="primary--text">Additonal Info :</b>
                {{ itemfield.additonal_info }}
              </span>
              <br />
              <v-list
                three-line
                v-for="(item, index) in expenseList"
                :key="item.header"
                dense
              >
                <v-list-item :key="item.title">
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="item.merchant_name"
                    ></v-list-item-title>

                    <v-list-item-subtitle
                      >Category : {{ item.mcc_desc }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      >#Txn ID : {{ item.rr_number }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle>{{
                      item.txn_type
                    }}</v-list-item-subtitle>

                    <v-list-item-title
                      >{{ item.currency }} {{ item.amount }}</v-list-item-title
                    >
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text
                      v-text="item.txn_timestamp"
                    ></v-list-item-action-text>
                    <v-list-item-avatar
                      size="40"
                      @click="openImageInNewTab(item.Url)"
                    >
                      <v-img :src="item.Url"></v-img>
                    </v-list-item-avatar>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="index < expenseList.length - 1"
                  :key="index"
                ></v-divider>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog> -->
      <OverleyProccessg :overlay="overlay" />
      <!-- <PartialApprove ref="ViewReceiptDetails" v-on:backChild="callstatus()" /> -->
      <Expenserecoveryview
        v-if="Show == true"
        :ExpenseList="ExpenseList"
        @backOn="callstatus()"
        :expenseid="expenseid"
        :PropItem="PropItem"
      />
    </v-card>
  </div>
</template>
<script>
// import PartialApprove from "@/components/ExpenseSubFol/PartialApprove.vue";
import Expenserecoveryview from "@/components/ExpenseSubFol/Expenserecoveryview.vue";
//import ApproveViewDetailsCust from "@/components/CustomerSubfolder/ApproveViewDetailsCust.vue";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  props: {
    tab: Number,
  },
  components: {
    OverleyProccessg,
    // PartialApprove,
    Expenserecoveryview,
  },
  data: () => ({
    Show: false,
    expenseid: "",

    checkaccessdata: {},
    modalStart: false,
    modalEnd: false,
    singleSelect: false,
    actionDialogeStatus: false,
    selectPayee: 0,
    empitems: [],
    totalPayment: 0,
    Employeelist: ["Nithin R Raghav"],
    contentDialog: false,
    start_date: null,
    commentExpense: "",

    amount: "",
    end_date: null,
    receiptStatus: false,

    workflowType: "Customer Onboarding",
    partialPending: [],
    Nodata: "",
    headers: [
      {
        text: "SL NO",
        align: "left",
        sortable: false,
        value: "sl_no",
      },

      // align: ' d-none'
      {
        text: "NAME",
        align: "left",
        sortable: false,
        value: "user_detail",
      },
      {
        text: "EXPENSE NAME",
        align: "left",
        sortable: false,
        value: "expense_name",
      },
      {
        text: "DATE & TIME",
        value: "created_on",
        align: "left",
        sortable: false,
      },
      {
        text: "TOTAL AMT(MYR)",
        value: "total_amount",
        sortable: false,
        align: "left",
      },
      {
        text: "APPROVED AMT(MYR)",
        value: "approved_amount",
        sortable: false,
        align: "left",
      },

      {
        text: "RECOVERY AMT(MYR)",
        value: "remaining_amount",
        sortable: false,
        align: "left",
      },
      // {
      //   text: "#Mobile No.",
      //   value: "mobile_no",
      //   align: "start",
      //   sortable: false,
      // },
      // {
      //   text: "Initiated On",
      //   value: "initiated_on",
      //   align: "start",
      //   sortable: false,
      // },

      { text: "VIEW", value: "actions", align: "left", sortable: false },
    ],
    overlay: false,
    selected: [],
    search: "",
    itemfield: "",

    UserList: [],
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
    PropItem: {},
    ExpenseList: [],
  }),
  created() {
    this.tab = 0;

    this.getcountNotification();
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.checkaccess();
  },
  watch: {
    selected() {
      //  console.log(this.selected.length);
      if (this.selected.length == 0) {
        // this.getApprovePay();
        this.resetBal();
      } else if (this.selected.length != 0) {
        // this.getApprovePay();
        this.balAndDebit();
      }
    },
    Show(val){
      if(val == true){
        this.$emit("ShowvalueRecvry", val);
       
      }else{
        this.$emit("ShowvalueRecvry", val);
      }
    }
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "EXRVRY",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getEmpDetails();
        this.getExpenseApprData();
      }
    },
    actionDialogeStatus1() {
      this.amount = this.totalPayment;
      this.actionDialogeStatus = true;
    },
    async collectamt() {
      // console.log("sda", this.selected);
      var new_selected_expense = [];
      for (let i = 0; i < this.selected.length; i++) {
        new_selected_expense.push(this.selected[i].expense_id);
      }
      var inputData = {
        method_name: "EXPRECVRY",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "RECOVER",
          expense_id: new_selected_expense,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log(responseData);
      if (responseData.data.status == "00") {
        this.getcountNotification();
        this.getExpenseApprData();
        this.actionDialogeStatus = false;

        // this.$emit("GoToHistory");
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
      }
      this.$refs.commentForm.reset();
    },

    // async getEmpDetails() {
    //   var inputData = {
    //     method_name: "ADMINCUST",
    //     page_no: 1,
    //     record_count: 0,
    //     page_size: null,
    //     app_code: "APORTAL",
    //     method_param: {
    //       action: "CUSTVIEW",
    //       search_text: "",
    //       corp_id: this.$store.getters.get_corpid,
    //       type: "0",
    //     },
    //   };
    //   var responseData = await apiCall(inputData);
    //   // console.log("filter", responseData);
    //   this.empitems.push({
    //     full_name: "All",
    //     email_id: "All",
    //   });

    //   var res = responseData.data.data == null ? [] : responseData.data.data;
    //   // console.log("res", res);
    //   res.forEach((element) => {
    //     this.empitems.push({
    //       full_name: element.full_name,
    //       email_id: element.email_id,
    //     });
    //   });
    //   //console.log(this.empitems);
    // },
    resetBal() {
      // console.log(this.bal)
      this.totalPayment = 0;
    },
    balAndDebit() {
      // console.log("selected", this.selected);s
      let sum = 0;
      for (let i = 0; i < this.selected.length; i++) {
        sum = parseFloat(sum) + parseFloat(this.selected[i].remaining_amount);
        this.totalPayment = sum.toFixed(2);
        // console.log(" this.totalPayment", this.totalPayment)

        // this.totalBalance = this.bal - this.totalPayment;
      }
    },
    callstatus() {
      this.Show = false;
      this.getExpenseApprData();
    },
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log(responseData, "responseData");
      // if (responseData.data.data[0].module_code == "CARDFUNDS") {
      //   this.corpcount = responseData.data.data[0].count;
      //   this.$store.commit("SET_FundCount", this.corpcount);
      //   // console.log("corpcount", this.corpcount);
      // }
      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            // console.log("custcount", this.custcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            //  console.log("corpcount", this.corpcount);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            //  console.log("corpcount", this.corpcount);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            break;
        }
      }
    },
    async getExpenseApprDataPagination() {
      if (this.partialPending.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "EXPRECVRY",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "LIST",
            corp_id: this.$store.getters.get_corpid,
            user_id: this.selectPayee, //this.$store.getters.get_userid,
            search_text: "",
            from_date: this.start_date,
            to_date: this.end_date,
            type: this.tab == 0 ? "1" : "2",
          },
        };

        var responseData = await apiCall(inputData);

        this.partialPending = this.partialPending.concat(
          responseData.data.data
        );
      }
    },
    async getEmpDetails() {
      var inputData = {
        method_name: "CORPFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETCARDUSERS",
          search_text: "",
          corp_id: this.$store.getters.get_corpid,
          type: "0",
        },
      };
      var responseData = await apiCall(inputData);

      this.UserList =
        responseData.data.data == null ? [] : responseData.data.data;

      this.UserList.unshift({
        full_name: "All",
        userid: 0,
      });
    },
    async getExpenseApprData() {
      var inputData = {
        method_name: "EXPRECVRY",
        page_no: 0,
        record_count: 0,
        page_size: 50,
        app_code: "CPORTAL",
        method_param: {
          action: "LIST",
          corp_id: this.$store.getters.get_corpid,
          user_id: this.selectPayee, //this.$store.getters.get_userid,
          search_text: "",
          from_date: this.start_date,
          to_date: this.end_date,
          type: this.tab == 0 ? "1" : "2",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("expenselist", responseData);
      if (responseData.data.status == "00") {
        this.partialPending =
          responseData.data.data == null ? [] : responseData.data.data;

        this.totalCount = responseData.data.data[0].total_count;
      } else if (responseData.data.status == "NOREC") {
        this.partialPending = [];
        this.Nodata = responseData.data.status_msg;
      }

      this.overlay = false;
    },
    async showContent(item) {
      this.overlay = true;
      //console.log(item);
      this.expenseid = item.expense_id;
      this.Show = true;
      this.PropItem = item;

      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GEXPTXN",
          expense_id: item.expense_id,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData.data.data)", responseData.data.data);
      if (responseData.data.status == "00") {
        this.ExpenseList =
          responseData.data.data == null ? [] : responseData.data.data;

        // console.log("expenseList", this.ExpenseList);
      }
      this.overlay = false;
      // this.expenseList.forEach((element) => {
      //   element.Url =
      //     element.receipt_url != null ? element.receipt_url[0] : null;
      //   element.classValue =
      //     element.amount > element.expense_rules.amount
      //       ? "font-weight-bold red--text"
      //       : "font-weight-bold";
      //   element.classValue2 =
      //     element.amount > element.expense_rules.amount
      //       ? "font-weight-bold red--text"
      //       : "font-weight-medium";
      // });
      // this.receiptStatus = true;
      // this.ExpenseHistoryView = responseData.data.data;
      // // console.log("viewHistoryArray", this.viewHistoryArray);
      // this.overlay = false;
      // this.receiptStatus = true;
      // this.$refs.ExpenseHistoryView.receiptStatus = true;
      // this.$refs.ExpenseHistoryView.itemfield = item;
      // this.$refs.ExpenseHistoryView.itemfield.usertype =
      //   this.expenseList.length == 0
      //     ? "-"
      //     : this.expenseList[0].expense_rules.usertype;
      // this.$refs.ExpenseHistoryView.itemfield.usertype_name =
      //   this.expenseList.length == 0
      //     ? "-"
      //     : this.expenseList[0].expense_rules.usertype_name;
      // var self = this;
      // self.expenseList.forEach(function (ele) {
      //   ele.approval_status1 = ele.approval_status;
      // });
      // this.$refs.ExpenseHistoryView.expenseList = this.expenseList;

      //  console.log(this.$refs.ExpenseHistoryView);
    },
    getFileName(filename) {
      //   console.log("vvv", filename);
      var url = filename.split("/");
      var len = url.length;
      const sample = url[len - 1];
      return sample;
    },
    convertDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
<style scoped>
.v-data-table {
  white-space: nowrap;
}
</style>
